// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".upcoming-filterbar{padding-left:64px;padding-right:64px;margin:0 auto;width:100%;max-width:1752px}@media(max-width:1050px){.upcoming-filterbar{padding-right:15px;padding-left:15px}}", ""]);
// Exports
module.exports = exports;
